import { Spinner } from '@/Domain/components/Shared/Spinner';
import { cn } from '@/Domain/utils/cn';

export const RouteFallback = ({ fullScreen = false }: { fullScreen?: boolean }) => (
  <div
    data-testid="route-loading"
    className={cn(
      'flex items-center justify-center',
      fullScreen ? 'h-screen w-screen' : 'flex-1 min-h-0',
    )}
  >
    <Spinner className="h-8 w-8 text-muted-foreground" />
  </div>
);
